import React from 'react';
import Button from 'jd-library/Button';
import styles from './button.scss'

const ButtonWrapper = React.forwardRef((props, ref) => {
	const {
		variant = 'primary'
	} = props;
	return (
		<Button
			{...props}
			variant={variant}
			ref={ref}
			className={`${styles['misc-btn']} ${styles[variant]} ${props.className || ''}`}
		/>
	)
})

export default ButtonWrapper